import React, { useState } from 'react';

import '../../css/LensRecommendV2.css';
import LensRecommendDetailFrame from './LensRecommendDetailFrame';
import LensRecommendListFrame, { createDefaultListQuery } from './LensRecommendListFrame';

/**
 * ICL Vault AI v2 진입점
 * List → 상세(신규/기존 공통)
 * 신규 등록도 상세 화면에서 그대로 진행하므로 저장 후 화면 전환이 없다.
 * 목록 검색 조건·결과는 상위 state 로 유지해 상세에서 돌아와도 초기화되지 않는다.
 * 기존 LensRecommendFrame 은 변경하지 않고 병행한다.
 */
export default function LensRecommendV2Frame() {
  const [detailContext, setDetailContext] = useState(null);
  const [listQuery, setListQuery] = useState(createDefaultListQuery);
  const [listRows, setListRows] = useState([]);
  const [listError, setListError] = useState('');
  const [listSearched, setListSearched] = useState(false);

  if (detailContext) {
    return (
      <div className="lens-frame">
        <LensRecommendDetailFrame
          key={detailContext.key}
          chartNo={detailContext.chartNo}
          eye={detailContext.eye}
          caseId={detailContext.caseId}
          seedRow={detailContext.seedRow}
          recordMode={detailContext.recordMode}
          onBack={() => setDetailContext(null)}
        />
      </div>
    );
  }

  return (
    <div className="lens-frame">
      <LensRecommendListFrame
        query={listQuery}
        onQueryChange={setListQuery}
        rows={listRows}
        onRowsChange={setListRows}
        error={listError}
        onErrorChange={setListError}
        searched={listSearched}
        onSearchedChange={setListSearched}
        onCreate={() =>
          setDetailContext({
            key: `new-${Date.now()}`,
            chartNo: '',
            eye: 'OD',
            caseId: '',
            seedRow: null,
            recordMode: 'new'
          })
        }
        onOpenDetail={({ chartNo, eye, caseId, seedRow }) =>
          setDetailContext({
            key: caseId || `${chartNo}-${eye}`,
            chartNo,
            eye,
            caseId: caseId || seedRow?.caseId || seedRow?.case_id || '',
            seedRow,
            recordMode: 'existing'
          })
        }
      />
    </div>
  );
}
